import EventEmitter from "eventemitter3";
import VideoPlayer from "./Videoplayer";
// import mainVideo from "assets/videos/02_Transition.mp4"; // TODO.

export default class Interactive extends EventEmitter {

    constructor(viewport, navigation) {
        super();

        this.viewport = viewport;
        this.navigation = navigation;
        // b.on interaction, replace with 02
        // this.mainVideo = new VideoPlayer(viewport, _TEMPLATEURI + '/assets/videos/02_Transition.mp4#t=0.1', 'main', {autoplay: false});
        this.mainVideo = new VideoPlayer(viewport, null, 'main', {autoplay: false});
        // Initialise Video 2  #childVideo --> NO MORE dynamic src replacement
        this.childVideo = new VideoPlayer(viewport, null, 'child', {autoplay: true});
        // Events
        this._addEvents();

    }

    // ------------------------------------------------------------------------------------------------
    // Public
    // ------------------------------------------------------------------------------------------------

    go() {
        // this._showMain()
        this.mainVideo.play();
    }

    stopAll() {
        // Stop all videos whatsoever
        // console.log('STOPPING ALL VIDS')
        $$('video').map((i, v) => {
            v.pause()
        })
    }


    // ------------------------------------------------------------------------------------------------
    // Private
    // ------------------------------------------------------------------------------------------------
    _addEvents() {
        let self = this;

        // -----------------------------------------------------------------------------------------------
        // MAIN VIDEO

        this.mainVideo.on('video:ready', () => {
            console.log(':::: INTERACTIVE READY')
            this.emit('ready');   // let the main class know
        });


        // progress
        this.mainVideo.on('video:play', () => {
                let i = setInterval(function () {
                    // console.log(self.mainVideo.videoEl.currentTime);
                    if (self.mainVideo.videoEl.paused || self.mainVideo.videoEl.currentTime > 18) {
                        clearInterval(i);
                        // Show menu buttons BEFORE TIME
                        self.emit('controls', true);

                    }
                }, 300);
            }
        );


        // -------------------
        // Main Video has completed
        //  Enable controls
        //
        this.mainVideo.on('video:ended', () => {
            // State = activate buttons, enable child video
            // this.emit('controls', true); // NOTE: this is now in progress!
            // Notify parent
            this.emit('main:ended');
        });


        // -----------------------------------------------------------------------------------------------
        // CHILD VIDEO

        /**
         * Child video ready to go
         *
         */
        this.childVideo.on('video:ready', () => {
            this.emit('video:active', 'child');
            // Play active video
            this.childVideo.play();
            // Notify parent to remove controls
            // this.emit('video:start');
            this.emit('child:start');

            // TODO: this is now the main button. ADD ANOTHER!
            //
            // Show video close button
            $$('#closeClient').css('display', 'initial')

        });

        /**
         * Child video ended.
         * Swap layers to show main
         */
        this.childVideo.on('video:ended', () => {
            // Set main video ui active
            this.emit('video:active', 'main');

            // Replay main video
            // this.mainVideo.restart();

            // Notify parent
            this.emit('child:ended');
            // Show controls
            this.emit('controls', true);

            // TODO: clean up
            // HIDE video close button
            $$('#closeClient').css('display', 'none')
        });


        // -----------------------------------------------------------------------------------------------
        // Controls : Change child video src, navigate
        //
        /*
            This is a case for reactive / duix
            To circumvent the new instanciation of an existing component (nav)
            ...
         */
        this.navigation.on('nav:video', (payload) => {
            if (payload === 'videoclose') {
                // Close, stop child video.
                this.childVideo.stop();
                this.childVideo.emit('video:ended');
                // this._showMain();
                // Restart MAIN video -- we need it unmuted.
                // this.mainVideo.play(true);
                // this.mainVideo.pause()
            } else {
                this.childVideo.setSource(_TEMPLATEURI + '/assets/videos/' + payload + '.mp4');
                // this._showChild()
            }
            this.childVideo.play()
        });

    }

    // _showMain() {
    //     $$("video_child").css('z-index', "-1")
    //     $$("video_main").css('z-index', "1")
    //     // $$("#video_main").css('display', "block")
    //     // $$("#video_child").css('display', "none")
    // }
    //
    // _showChild() {
    //     $$("video_child").css('z-index', "1")
    //     $$("video_main").css('z-index', "-1")
    //     // $$("#video_child").css('display', "block")
    //     // $$("#video_main").css('display', "none")
    // }

}
